<template>
  <div
    class="choose-name container h-overflow-scroll"
    :style="`background-image: url(${backgroundImage}); background-repeat: no-repeat; background-size: cover;`"
  >
    <div class="is-text-bold is-text-orange is-uppercase is-size-small">
      {{ $t("choose_name.headline") }}
    </div>
    <div class="gap-4" />

    <div class="input-wrap">
      <img src="@/assets/images/name-indicator.svg" class="name-indicator" />
      <input
        type="text"
        class="input is-text-bold"
        placeholder="Player One"
        v-model="namePlayerOne"
      />
    </div>

    <div class="input-wrap">
      <img
        src="@/assets/images/name-indicator.svg"
        class="name-indicator bottom"
      />
      <input
        type="text"
        class="input is-text-bold"
        placeholder="Player Two"
        v-model="namePlayerTwo"
        v-on:keyup.enter="goToFight()"
      />
    </div>
    <div class="gap-4" />
    <div class="button" @click="goToFight()">{{ $t("choose_name.cta") }}</div>
  </div>
</template>

<script>
import { useGameTracking } from "@/composables/useGameTracking";

export default {
  data() {
    return {
      hasEnteredName: false,
    };
  },
  created() {
    // Initialize enteredCrmData to false at the beginning
    const { kpiTracker } = useGameTracking();
    kpiTracker.setEnteredCrmData(false);
  },
  computed: {
    backgroundImage() {
      return require("@/assets/images/bg-green-xl.jpg");
    },
    namePlayerOne: {
      get() {
        return this.$store.state.namePlayerOne;
      },
      set(val) {
        this.$store.commit("setNamePlayerOne", val);
        // Track if at least one name has been entered
        if (val && val.trim().length > 0) {
          this.hasEnteredName = true;
        } else if (
          !this.namePlayerTwo ||
          this.namePlayerTwo.trim().length === 0
        ) {
          this.hasEnteredName = false;
        }
      },
    },
    namePlayerTwo: {
      get() {
        return this.$store.state.namePlayerTwo;
      },
      set(val) {
        this.$store.commit("setNamePlayerTwo", val);
        // Track if at least one name has been entered
        if (val && val.trim().length > 0) {
          this.hasEnteredName = true;
        } else if (
          !this.namePlayerOne ||
          this.namePlayerOne.trim().length === 0
        ) {
          this.hasEnteredName = false;
        }
      },
    },
  },
  methods: {
    async goToFight() {
      document.querySelectorAll(".input").forEach((i) => i.blur());
      this.clickSound.play();

      const { kpiTracker, session } = useGameTracking();

      // Check if at least one name has been entered
      const enteredCrmData = Boolean(
        this.hasEnteredName ||
          (this.namePlayerOne && this.namePlayerOne.trim().length > 0) ||
          (this.namePlayerTwo && this.namePlayerTwo.trim().length > 0)
      );

      // Set entered_crm_data based on whether names were entered (explicitly as boolean)
      kpiTracker.setEnteredCrmData(enteredCrmData);

      // Start game play time tracking
      kpiTracker.setGamePlayTimeStart(Date.now());

      // Set Progress auf 2 (game_started)
      kpiTracker.setProgress(2);

      // Prepare choosen_names array (use empty strings if nothing entered)
      // WICHTIG: choosen_names werden sowohl bei game_started als auch bei game_finished mitgesendet
      const choosenNames = [
        this.namePlayerOne && this.namePlayerOne.trim().length > 0
          ? this.namePlayerOne
          : "",
        this.namePlayerTwo && this.namePlayerTwo.trim().length > 0
          ? this.namePlayerTwo
          : "",
      ];

      // Update Session mit Progress "game_started"
      try {
        await session.updateSessionProgress(kpiTracker.getKpiData(), {
          step: "game_started",
          choosen_names: choosenNames,
        });
      } catch (error) {
        console.error("Error updating session:", error);
      }

      this.currentStep = "fight";
    },
  },
};
</script>

<style lang="sass" scoped>
@import "@/assets/sass/abstracts/variables"
.choose-name
  padding: 4rem 3rem

  .input-wrap
    width: 100%
    .name-indicator
      width: 10%
      height: 5.4rem
      margin-bottom: -2.7rem
      margin-right: 3%
      &.bottom
        transform: rotate(180deg)
</style>
